import classNames from 'classnames'
import React from 'react'
import { ValueLocked } from 'src/components/framework/icons/value-locked'
import * as styles from 'src/components/page/ratios/ratio-graph.module.scss'

export interface Props {
  percentile: number
  locked?: boolean
}

export const RatioGraph: React.FC<Props> = ({ percentile, locked = false }) => {
  const theme = getTheme(percentile)
  return (
    <>
      {locked ? (
        <div className={styles.ratioGraphLocked}>
          <div className={'stk-progress-bar'} />
          <div className={styles.ratioGraphLocked__icon}>
            <ValueLocked />
          </div>
        </div>
      ) : (
        <>
          <div
            className={classNames('stk-progress-bar', {
              [`stk-progress-bar--${theme}`]: !!theme,
            })}
          >
            <div
              className={'stk-progress-bar__indicator'}
              style={{ width: `${percentile}%`, minWidth: '1px' }}
            />
          </div>
        </>
      )}
    </>
  )
}

enum ProgressBarTheme {
  SuperGreen = 'super-green',
  StrongGreen = 'strong-green',
  WarmYellow = 'warm-yellow',
  Amber = 'amber',
  SuckerRed = 'sucker-red',
  Neutral = 'neutral',
}

function getTheme(percentile: number): ProgressBarTheme {
  let theme: ProgressBarTheme

  switch (true) {
    case 80 <= percentile:
      theme = ProgressBarTheme.SuperGreen
      break
    case 60 <= percentile:
      theme = ProgressBarTheme.StrongGreen
      break
    case 40 <= percentile:
      theme = ProgressBarTheme.WarmYellow
      break
    case 20 <= percentile:
      theme = ProgressBarTheme.Amber
      break
    default:
      theme = ProgressBarTheme.SuckerRed
  }

  return theme
}
